import { typesGlob } from "..";

const rootArea = "/related";

export const relatedGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (relationshipCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${relationshipCode}/read`,
		create: `${baseArea}${rootArea}/${relationshipCode}/create`,
		update: `${baseArea}${rootArea}/${relationshipCode}/update`,
		deactivate: `${baseArea}${rootArea}/${relationshipCode}/deactivate`,
		reactivate: `${baseArea}${rootArea}/${relationshipCode}/reactivate`,
		types: typesGlob(`${baseArea}${rootArea}/${relationshipCode}`)
	})
});